<template>
    <span
        class="tooltip"
        :class="this.positionClass"
        :data-tooltip="formatted"
    >
        {{timeSince}}
    </span>
</template>

<script>
import moment from 'moment';
import TimeUtil from '$flx/util/TimeUtil';
export default {
    name : 'TimeSince',
    props : {
        value : [Number, String],
        or : {
            type : String,
            default : 'N/A',
        },
        displayInUtc : {
            type : Boolean,
            default : false,
        },
        dateFormat : {
            type : String,
            default : 'M/D/YY'
        },
        timeFormat : {
            type : String,
            default : 'h:mm:ss A',
        },
        fullFormatOverride : {
            type : String,
            default : null,
        },
        position : {
            type : String,
            default : 'right',
        },
    },
    computed : {
        timeSince () {
            return TimeUtil.timeSince(this.value, this.or);
        },
        formatted () {
            if(!this.value) {
                return null;
            }
            let date = moment.utc(this.value);
            if(!this.displayInUtc){
                date = date.local();
            }
            return date.format(`${this.dateFormat} ${this.timeFormat}`);
        },
        positionClass () {
            return 'is-tooltip-' + this.position;
        },
    },
}
</script>

<style scoped>

</style>
